import Rostov from './coordinates/Rostov/Rostov.json';

export default {
    regionCode: 'rostov',
    serviceAreas: [
        {
            id: 'rostov-1',
            include: [
                {
                    name: 'Ростов',
                    type: 'polygon',
                    coordinates: Rostov,
                },
            ],
        },
        {
            id: 'rostov-2',
            include: [
                {
                    name: 'Ростов (расстояние 30км)',
                    type: 'polygon',
                    coordinates: Rostov,
                    distance: true,
                    maxDistance: 30
                },
            ],
        },
    ],
};
